// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"544": "745e4b29","5981": "9200fc8d","9862": "ec44fc47",}[chunkId] + ".css"
}